import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material/styles';
import { AppRouter } from 'router/AppRouter';
import { UserDataContextProvider } from 'components/UserDataContext/UserDataContextProvider';
import { FiltersContextProvider } from 'components/FiltersContext/FiltersContextProvider';
import ErrorBoundary from './components/ErrorBoundary';
import 'vetrf-ui/dist/vetrf-ui.css';
import 'vendor/styles/vendor.css';
import 'assets/nomalize.css';

import 'assets/css/address.css';
import 'assets/css/admin-page.css';
import 'assets/css/irena.css';
import 'assets/css/card-list.css';
import 'assets/css/infobox.css';
import 'assets/css/toggle-text.css';
import 'assets/css/switch-view.css';
import 'assets/css/react-checkbox-tree.css';
import 'assets/css/font-vetis.css';
import 'assets/css/page-toolbar.css';
import 'assets/css/animation.css';
import './index.scss';

const App = () => (
  <ErrorBoundary>
    <StyledEngineProvider injectFirst>
      <BrowserRouter basename="/react">
        <Suspense fallback={<div />}>
          <UserDataContextProvider>
            <FiltersContextProvider>
              <AppRouter />
            </FiltersContextProvider>
          </UserDataContextProvider>
        </Suspense>
      </BrowserRouter>
    </StyledEngineProvider>
  </ErrorBoundary>
);

ReactDOM.render(<App />, document.getElementById('root'));
